import BaseModel from "./BaseModel";

export enum SubmissionStatus {
  waiting_audio = "waiting_audio",
  pending = "pending",
  re_submitted = "re_submitted",
  approved = "approved",
  rejected = "rejected",
}
export default class CandidateSubmissionModel extends BaseModel {
  status?: SubmissionStatus;
  sound_record?: string;
  constructor(arg: any) {
    super(arg);
    this.status = arg.status;
    this.sound_record = arg.sound_record;
  }
}
